/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: Manually maintained — do NOT regenerate. See CLAUDE.md "Important Notes" #1.
 */

import { exists } from '../runtime';

/**
 * NotificationTemplate model — courier-customised notification message
 * overrides, keyed by (realm, event, channel). A missing row means
 * "use the built-in default" so couriers without customisations see no change.
 *
 * @export
 * @interface NotificationTemplate
 */
export interface NotificationTemplate {
  /**
   * @type {string}
   * @memberof NotificationTemplate
   */
  id?: string;
  /**
   * Courier realm — auto-injected from the access token on create/upsert.
   * @type {string}
   * @memberof NotificationTemplate
   */
  realm?: string;
  /**
   * Event key, e.g. 'package_status.ready' or 'onboarding.welcome'.
   * See backend common/models/notification-template.js VALID_EVENTS.
   * @type {string}
   * @memberof NotificationTemplate
   */
  event: string;
  /**
   * Delivery channel: 'email' | 'whatsapp' | 'push'.
   * @type {string}
   * @memberof NotificationTemplate
   */
  channel: string;
  /**
   * Whether this override is active. Disabled rows are skipped at render time.
   * @type {boolean}
   * @memberof NotificationTemplate
   */
  enabled?: boolean;
  /**
   * Subject for email; title for push; unused for WhatsApp.
   * @type {string}
   * @memberof NotificationTemplate
   */
  subject?: string | null;
  /**
   * Mustache body template — HTML for email, plain text (with *bold*) for
   * WhatsApp, plain text for push.
   * @type {string}
   * @memberof NotificationTemplate
   */
  body: string;
  /**
   * CourierUser id of the last admin who modified this row.
   * @type {string}
   * @memberof NotificationTemplate
   */
  updatedBy?: string;
  /**
   * @type {Date}
   * @memberof NotificationTemplate
   */
  createdAt?: Date;
  /**
   * @type {Date}
   * @memberof NotificationTemplate
   */
  updatedAt?: Date;
}

export function instanceOfNotificationTemplate(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && 'event' in value;
  isInstance = isInstance && 'channel' in value;
  isInstance = isInstance && 'body' in value;
  return isInstance;
}

export function NotificationTemplateFromJSON(json: any): NotificationTemplate {
  return NotificationTemplateFromJSONTyped(json, false);
}

export function NotificationTemplateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NotificationTemplate {
  if (json === undefined || json === null) return json;
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    realm: !exists(json, 'realm') ? undefined : json['realm'],
    event: json['event'],
    channel: json['channel'],
    enabled: !exists(json, 'enabled') ? undefined : json['enabled'],
    subject: !exists(json, 'subject') ? undefined : json['subject'],
    body: json['body'],
    updatedBy: !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    createdAt: !exists(json, 'createdAt')
      ? undefined
      : new Date(json['createdAt']),
    updatedAt: !exists(json, 'updatedAt')
      ? undefined
      : new Date(json['updatedAt']),
  };
}

export function NotificationTemplateToJSON(
  value?: NotificationTemplate | null
): any {
  if (value === undefined) return undefined;
  if (value === null) return null;
  return {
    id: value.id,
    realm: value.realm,
    event: value.event,
    channel: value.channel,
    enabled: value.enabled,
    subject: value.subject,
    body: value.body,
    updatedBy: value.updatedBy,
    createdAt:
      value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
    updatedAt:
      value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
  };
}

/**
 * sendTest request body.
 */
export interface NotificationTemplateSendTestRequest {
  event: string;
  channel: string;
  to: string;
  subject?: string;
  body?: string;
  sampleContextOverrides?: Record<string, unknown>;
  /**
   * Render and send as this courier instead of the caller's own. Overlord-only —
   * anyone else naming a realm other than their own gets a 403. Used by the admin
   * so a "Send test" while impersonating comes from the impersonated courier's
   * mail account / WhatsApp session rather than the Overlord's.
   */
  realm?: string;
  /**
   * Send the built-in package status email a customer receives when the courier
   * keeps the default, instead of a template. Email + package_status.* only.
   */
  useBuiltIn?: boolean;
}

/**
 * The built-in message a customer receives when the courier keeps the default.
 */
export interface NotificationTemplateBuiltInPreview {
  subject: string | null;
  /** The full delivered email (courier shell included) when format is 'html'. */
  body: string;
  format: 'html' | 'text';
}

/**
 * sendTest response.
 */
export interface NotificationTemplateSendTestResult {
  rendered: { subject: string | null; body: string | null };
  usedDefault?: boolean;
  transportResult?: unknown;
  renderError?: string;
  transportError?: string;
  /**
   * The realm the test actually rendered and sent as. Echoed back so the admin
   * can see at a glance which courier it went out as.
   */
  resolvedRealm?: string;
  /**
   * Set when the transport was deliberately not attempted (e.g. a push test for
   * a courier the caller has no registered device against). Distinguishes
   * "nothing was sent" from a successful send.
   */
  transportSkipped?: string;
}
